export const MARKETING_CARD_WIDTH_DESKTOP = 344;
export const MARKETING_CARD_WIDTH_DESKTOP_LG = 441;
